import { Controller } from '@hotwired/stimulus';

export default class TabController extends Controller {
  static targets = ['tab', 'pane'];
  static values = {
    shouldReload: Boolean,
  };

  connect() {
    window.addEventListener('popstate', this.handlePopState);
    if (this.shouldReloadValue) {
      this.scrollActiveTabIntoView('instant');
    }
  }

  disconnect() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;

    const href = clickedTab.getAttribute('href');
    if (this.shouldReloadValue) {
      window.location = href;
      return;
    }
    this.activateTab(clickedTab.dataset.category);
    history.pushState(null, '', href);
    clickedTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  handlePopState = () => {
    const matchingTab = this.tabTargets.find((tab) => tab.getAttribute('href') === window.location.pathname);

    if (matchingTab) {
      this.activateTab(matchingTab.dataset.category);
    }
  };

  scrollActiveTabIntoView(behavior) {
    const activeTab = this.tabTargets.find((tab) => tab.classList.contains('active'));
    if (activeTab) {
      activeTab.scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
    }
  }

  activateTab(category) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.category === category;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.paneTargets.forEach((pane) => {
      const isActive = pane.id === category;
      pane.classList.toggle('show', isActive);
      pane.classList.toggle('active', isActive);
    });
  }
}
